"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartError = void 0;
/**
 * An Error wrapper for CartMessage
 */
class CartError extends Error {
    /**
     * Creates a new instance from a CartMessage
     * @param {ICartMessage} message
     */
    constructor(message) {
        super(message.message);
        this.code = message.code;
        this.field = message.field;
        this.type = message.type;
    }
}
exports.CartError = CartError;
